import React, {useContext} from 'react';
// @ts-ignore
import {ColumnDiv, RowDiv} from "../../styledComponents/CustomStyledComponents";
import InfoBox from "./CountryInfoBox";
import {CountryReportData} from "../../../interfaces/RankingsAndLevelsInterfaces";

import {useTranslation} from "react-i18next";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {SkeletonLine} from "../../SkeletonLoader/SkeletonLoaders";
import Colors from "../../../assets/colors/Colors";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";

const CountryInfo: React.FC<{countryInfo: CountryReportData | undefined}> = ({countryInfo= {} }) => {
    const { t } = useTranslation();
    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const color = isLife ? Colors.fontWhite : Colors.fontGray;

    return (
        <ColumnDiv style={{flex: 1, justifyContent: 'flex-start', textAlign: 'justify'}}>
            <RowDiv style={{color: color, fontSize: 50}}>
                { allDataLoaded ? t(`countries.names.${ countryInfo.alpha2 }`) || countryInfo.name : <SkeletonLine count={1} width={200}/> }
            </RowDiv>
            <div style={{ color: color, fontFamily: 'Mapfre-Light', marginBottom: 40}}>
                { allDataLoaded ? t(`countries.${ countryInfo.alpha3 }.description`, t('rankingsAndLevels.description')) : <SkeletonLine count={6} width={400}/> }
            </div>

            <InfoBox showLinkButton={true} countryInfo={countryInfo} allDataLoaded={allDataLoaded}/>
        </ColumnDiv>
    )
};

export default CountryInfo;
